// actions
export const INCREMENT = "increment";
export const DECREMENT = "decrement";

const state = {
  count: 0,
};

const actions = {
  [INCREMENT]({ commit }) {
    commit(INCREMENT);
  },
  [DECREMENT]({ commit }) {
    commit(DECREMENT);
  },
};

const mutations = {
  [INCREMENT](state) {
    state.count++;
  },
  [DECREMENT](state) {
    state.count--;
  },
};

const getters = {
  isLoading(state) {
    return state.count > 0;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
